import React from 'react';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Toolbar from '@material-ui/core/Toolbar';
import UserManagementFunctions from '../../../../store/userManagement/functions';

interface IUserRegisterDialogProps {
    open : boolean;
    onClose : () => void;
    fullWidth ?: boolean;
    maxWidth ?: 'xs' | 'sm' | 'md' | 'lg' | false;
    fullScreen ?: boolean;
    transition ?: React.ForwardRefExoticComponent<TransitionProps & React.RefAttributes<unknown>>;

    isLoading : boolean;
}

interface IUserRegisterDialogState {
    name : string;
    employeeNumber : string;
}

export default class UserRegisterDialog extends React.Component<IUserRegisterDialogProps, IUserRegisterDialogState> {
    constructor(props : IUserRegisterDialogProps) {
        super(props);
        this.state = {
            name: '',
            employeeNumber: '',
        };
    }

    public componentDidUpdate = (prevProps : IUserRegisterDialogProps) => {
        if (prevProps.open && !this.props.open) {
            this.setState({
                name: '',
                employeeNumber: '',
            });
        }

    };

    private onSubmit = (event : React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        this.onCreateClick();
    };

    private onNameChange = (event : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({
            name: event.currentTarget.value,
        });
    };

    private onEmployeeNumberChange = (event : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({
            employeeNumber: event.currentTarget.value,
        });
    };

    private createEmployee = async () => {
        if (this.state.employeeNumber) {
            const result = await UserManagementFunctions.registerUser(this.state.employeeNumber, this.state.name);

            if (result) {
                this.props.onClose();
            }
        }
    };

    private onCreateClick = () => {
        this.createEmployee();
    };

    public render = () => {
        const { open, onClose, transition, maxWidth, fullWidth, fullScreen, isLoading } = this.props;
        const { name, employeeNumber } = this.state;

        return (
            <Dialog
                open={open}
                TransitionComponent={transition}
                transitionDuration={500}
                onClose={isLoading ? undefined : onClose}
                maxWidth={maxWidth}
                fullScreen={fullScreen}
                fullWidth={fullWidth}
                aria-labelledby='confirm-dialog-title'
                aria-describedby='confirm-dialog-description'
            >
                <AppBar className='fdr posr aic jcc' position='static'>
                    <Toolbar className={'fdr aic jcc'}>
                        <Typography variant='h5' color='inherit'>
                        Register Employee
                        </Typography>
                        <span className='flx1' />
                        <Tooltip title='Close'>
                            <div>
                                <IconButton color='inherit' disabled={isLoading} onClick={onClose} aria-label='Close'>
                                    <Icon>close</Icon>
                                </IconButton>
                            </div>
                        </Tooltip>
                    </Toolbar>
                </AppBar>
                <form autoComplete='off' onSubmit={this.onSubmit} className='fdc flx1 hfill'>
                    <DialogContent className='fdc flx1 hfill'>
                        <div className='fdc flx1 hfill'>
                            <div className={'aic mb10'}>
                                <FormControl fullWidth>
                                    <TextField
                                        autoComplete='off'
                                        id='name'
                                        label='Name'
                                        value={name ? name : ''}
                                        onChange={this.onNameChange}
                                        margin='normal'
                                        className={'TextField'}
                                    />
                                </FormControl>
                            </div>
                            <div className={'aic mb10'}>
                                <FormControl fullWidth>
                                    <TextField
                                        autoComplete='off'
                                        id='employeeNumber'
                                        label='Employee Number'
                                        value={employeeNumber ? employeeNumber : ''}
                                        required
                                        error={!employeeNumber}
                                        margin='normal'
                                        className={'TextField'}
                                        onChange={this.onEmployeeNumberChange}
                                    />
                                    {
                                        !employeeNumber &&
                                        <FormHelperText error>Required</FormHelperText>
                                    }
                                </FormControl>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={isLoading} type='submit' variant='contained' color='primary'>
                        OK
                        </Button>
                        <Button disabled={isLoading} variant='outlined' onClick={onClose} color='primary' autoFocus>
                        CANCEL
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    };
}
